import { useTranslation } from "react-i18next";

/**
 * Pinned total row for dashboard tables
 */
const PinnedRowRender = (param: any) => {

    const {t} = useTranslation('booking');

    const label = t('label.total');

    return (
        <>
            <span style={param.style}>{(param.field.includes(param.colDef.field)) || !param.colDef.field ? label : param.value}</span>
        </>
    );
}

export default PinnedRowRender;
